/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import DuvidasFrequentesPerguntas from '../../organisms/DuvidasFrequentesPerguntas/DuvidasFrequentesPerguntas';
import DuvidasFrequentesBanner25 from '@/components/organisms/DuvidasFrequentes25Banner';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import DuvidasFrequentes25Canais from '@/components/organisms/DuvidasFrequentes25Canais';

function DuvidasFrequentes() {
  return (
    <>
      <Head>
        <title>Duvidas Frequentes | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Tem dúvidas sobre produtos e serviços Santander Financiamentos? Encontre aqui respostas rápidas para suas perguntas frequentes. Acesse e saiba mais!"
        />
        <meta name="robots" content="index,follow" />
        <meta
          name="keywords"
          content="Santander Financiamentos, Perguntas e respostas, Ajuda, FAQ, Como funciona o financiamento, Segunda via boleto, Meu Financiamento Santander, Emitir boleto, Quitação de financiamento, Cancelamento de contrato, Open Finance Santander, Consultar contrato, Dúvidas frequentes, renegociar financiamento Santander, Documentos financiamento, Área do Cliente Santander, acordo financiamento Santander, antecipação de parcelas Santander Financiamentos, fale conosco Santander Financiamentos, alterar data de vencimento boleto Santander, como emitir boleto, como emitir um boleto, qual o desconto para quitação de financiamento de veículo, simular quitação de financiamento"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/duvidas-frequentes.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Duvidas Frequentes | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/duvidas-frequentes.html "
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Tem dúvidas sobre produtos e serviços Santander Financiamentos? Encontre aqui respostas rápidas para suas perguntas frequentes. Acesse e saiba mais!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/duvidas-frequentes25/hero/banner-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Mulher sorridente utilizando notebook para buscar tirar sua dúvida sobre financiamento de veículos, segunda via de boletos, renegociação de contrato no site da Santander Financiamentos."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Duvidas Frequentes | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Tem dúvidas sobre produtos e serviços Santander Financiamentos? Encontre aqui respostas rápidas para suas perguntas frequentes. Acesse e saiba mais!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/duvidas-frequentes.html "
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/duvidas-frequentes25/hero/banner-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Mulher sorridente utilizando notebook para buscar tirar sua dúvida sobre financiamento de veículos, segunda via de boletos, renegociação de contrato no site da Santander Financiamentos."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 />
      <DuvidasFrequentesBanner25 />
      <DuvidasFrequentesPerguntas />
      <DuvidasFrequentes25Canais />
      {/* <DuvidasFrequentesFormasAtendimento /> */}

      <Footer24 />
      {/* <style jsx>{Styles}</style> */}
    </>
  );
}

export default DuvidasFrequentes;
